import { useEffect, useRef, useState } from 'react';
import { currentUser, logout } from '../identity.js';

function phrase(status) {
  if (status.phase === 'syncing') return 'Syncing…';
  if (status.phase === 'offline') return status.pending ? `Offline · ${status.pending} waiting` : 'Offline';
  if (status.phase === 'error') return status.pending ? `Not synced · ${status.pending} waiting` : 'Not synced';
  if (status.pending) return `${status.pending} waiting`;
  if (!status.lastSyncedAt) return 'Not synced yet';
  return 'Synced';
}

const tone = status =>
  status.phase === 'error' ? ' is-bad'
    : status.phase === 'offline' ? ' is-warn'
    : status.pending ? ' is-warn'
    : '';

export default function SyncStatus({ status, onSyncNow }) {
  const [open, setOpen] = useState(false);
  const wrap = useRef(null);
  const user = currentUser();

  useEffect(() => {
    if (!open) return;
    const close = e => { if (!wrap.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [open]);

  return (
    <div className="account" ref={wrap}>
      <button
        className={'ghost-btn sync-btn' + tone(status)}
        aria-haspopup="menu" aria-expanded={open}
        title={status.lastError || 'Account and sync'}
        onClick={() => setOpen(v => !v)}
      >
        <span className={'sync-dot' + tone(status)} aria-hidden="true" />
        {phrase(status)}
      </button>

      {open && (
        <div className="menu account-menu" role="menu">
          <div className="account-email">{user?.email}</div>
          <div className="account-detail">
            {status.lastSyncedAt
              ? 'Last synced ' + new Date(status.lastSyncedAt).toLocaleTimeString()
              : 'This device has not synced yet.'}
          </div>
          {status.lastError && <div className="account-detail is-bad">{status.lastError}</div>}
          {!!status.pending && (
            <div className="account-detail">
              {status.pending} change{status.pending === 1 ? '' : 's'} still to send. Your writing is
              safe on this device meanwhile.
            </div>
          )}
          <div className="menu-rule" />
          <button className="menu-row" role="menuitem" onClick={() => { setOpen(false); onSyncNow(); }}>
            <span className="name">Sync now</span>
          </button>
          <button className="menu-row" role="menuitem" onClick={() => { setOpen(false); logout(); }}>
            <span className="name">Sign out</span>
          </button>
          <p className="menu-note">
            Signing out leaves this device&rsquo;s copy in place. Use Backup first if you are on
            someone else&rsquo;s computer.
          </p>
        </div>
      )}
    </div>
  );
}
